import React, {useState} from "react";
import Loading from "../../results/loading";
import Random from "../../results/random";
import {digits, onChangeDigits, onMouseEnter, onMouseLeave} from "../../../utility/General";
import {withTranslation} from "react-i18next";
import {getDate, getDateDisplay} from "../../../utility/dateUtils";

const ResultShow = (props) => {
    const {i18n, result, type, t, isQr = false} = props;
    const [activeDigit, setActiveDigit] = useState(0);
    const isKm = i18n.language === "km";

    let postA = result?.results[0][0].slice(-(type));


    const renderPostA = () => {
        if (postA.includes("*")) {
            return <span className="align-middle"><Loading sizeDigit={postA.length} className="loading-draw"/></span>
        } else if (postA.includes("?")) {
            return <span className="align-middle"><Random sizeDigit={postA.length}
                                                          className="draw-style-a text-post-A"/></span>
        } else return <span
            className={`big-result fs-qr-b-num f-result-num align-middle text-center text-post-A pop-able-number-${type}`}
            id="jack-port"
            data-num={postA}>{postA}</span>
    };

    return <div id="result-show text-white" className="animate-slide-up">
        <div className={`card-product prod-width ${isQr ? "" : "p-2"}`}>
            {isQr ? <div className="text-center font-weight-bold">
                <div className="result_header">
                    <div className={`result_date date_time ${isQr ? "fs-result-vn p-result-head-vn" : ""}`}>
                        <span>{getDateDisplay(result.drawDate)} - {t("labels:shift")} {result.drawTime} {t("labels:minutes")}</span>
                    </div>
                </div>
            </div> : <div className="row col-sm-12">
                <div className="col-sm-8 mt-3 mb-3" align="left">
                    <span
                        className="fw-bold head-result-date">{getDate(result.drawDate)} {t("labels:shift")} : {result.drawTime}</span>
                </div>
            </div>}
            <hr className="m-0 border-dark"/>
            <div className="row post-a m-0" id="post-a">
                <div className="col-2 card-border-right text-center post-a-vertical-middle bg-post-A text-white">
                    <p className={`align-middle ${isKm ? "f-result" : "f-result-en"}`}>{t("labels:grand_price")}</p>
                </div>
                <div className="col-10 text-center p-post-a big-result-loading align-self-center">
                <span
                    className="result-highlight big-result align-middle text-red-c f-tnr fs-qr-b-num">A</span>
                    <span
                        className="m-1 result-highlight big-result align-middle ml-2 mr-2 text-post-A fs-qr-b-num">=</span>
                    {
                        renderPostA()
                    }
                </div>
            </div>
            <hr className="m-0 border-dark"/>
            <div className="row p-0 m-0">
                <div className="col-2 m-0 p-0 card-border-right text-center lo-vertical-middle text-white">
                    <p className={isKm ? "f-result" : "f-result-en"}>{t("labels:reward_consolation")}<br/>{t("labels:consolation")}
                    </p>
                </div>
                <div className="col-10 mt-3 row mb-3">
                    {
                        result?.results[1].map((item, i) => {
                            if (item.includes("*")) {
                                return <div key={i} className="col-sm-3 text-center p-0 mb-4">
                                        <span className="result-highlight lo-result" key={i}><Loading
                                            sizeDigit={5}
                                            className="lo-loading mr-2"/></span>
                                </div>
                            }
                            if (item.includes("?")) {
                                return (<div key={i} className="col-sm-3 text-center p-0 mb-4">
                                    <span className="result-highlight lo-result" key={i}><Random
                                        sizeDigit={5}
                                        className="draw-style"/></span>
                                </div>)
                            }
                            return <div key={i} className="col-sm-3 text-center mb-4 p-0">
                                       <span
                                           className={`result-highlight fs-qr-lo-num lo-result pop-able-number-${type}`}
                                           data-length="5"
                                           data-num={item}>{item}</span>

                            </div>
                        })
                    }
                </div>
            </div>
            <hr className="m-0 border-dark"/>
            <div className="row m-0 post-special d-flex" id="post-spec">
                <div className="col-2 p-0 card-border-right text-center post-vertical-middle pr-0 bg-post-F text-white">
                    <p className={`${isKm ? "f-result" : "f-result-en"}`}>{t("labels:reward_spacial")}<br/>{t("labels:spacial")}
                    </p>
                </div>
                <div className="col-10 mt-2 mb-0">
                    <div className="row mr-1">
                        {
                            ["B", "F", "C", "I", "D", "N"].map((item, i) => {
                                let number = result?.results[2][i].slice(-(type));
                                const renderPostNum = () => {
                                    if (number.includes("*")) {
                                        return <span className="align-middle" key={i}>
                                                    <Loading
                                                        sizeDigit={number.length}
                                                        className="loading-draw"/>
                                               </span>
                                    } else if (number.includes("?")) {
                                        return <span className="align-middle" key={i}>
                                                    <Random sizeDigit={number.length}
                                                            className="result-highlight spacial-result draw-spacial-result text-post-F"/>
                                               </span>
                                    } else return <span key={i}
                                                        className={`result-highlight fs-qr-s-num align-middle spacial-result text-post-F pop-able-number-${type}`}
                                                        data-num={number}>{number}</span>


                                };
                                return (
                                    <div key={i}
                                         className={`col-6 p-0 text-center mb-2 pr-0 ${i < 4 ? "card-border-bottom" : ""}`}>
                                        <div
                                            className={`text-center mb-4 mt-3 spacial-result-loading ${i % 2 !== 1 ? "card-border-right" : ""}`}>
                                            <span
                                                className={`mt-2 fs-qr-s-num result-highlight spacial-result  text-red-c mb-0 align-middle ${item === "I" ? "f-tnr" : ""}`}>{item}</span>
                                            <span
                                                className="m-1 fs-qr-s-num result-highlight spacial-result text-blue-c align-middle text-post-F">=</span>
                                            {
                                                renderPostNum()
                                            }
                                        </div>
                                    </div>)
                            })
                        }
                    </div>
                </div>

            </div>
        </div>
        {/*Search Result*/}
        {!(result.status === "ACTIVE") && <div className="card-product boxBottom row p-0 m-0">
            <div className={`p-2 ${isQr ? "filter-balls-qr" : "filter-balls"}`}>
                {
                    digits.map((e, i) => {
                        let active = e.value === activeDigit ? " active-digit" : "";
                        return <span key={i}
                                     onClick={_ => onChangeDigits(type, e.value, activeDigit, setActiveDigit)}
                                     className={`filter-digits ${isQr ? "fs-result-footer" : ""} fw-digit ${active}`}>{t(`labels:${e.label}`)}</span>
                    })
                }
            </div>
            {
                Array(10).fill(0).map((_, i) => {
                    return <div key={i}
                                className={isQr ? "ball-num-qr" : "ball-num"}
                                onMouseEnter={() => onMouseEnter(type, i, activeDigit)}
                                onMouseLeave={() => onMouseLeave(type, activeDigit)}
                    >
                        <span className="p-0">{i}</span>
                    </div>
                })
            }

        </div>}
    </div>
};

export default (withTranslation()(ResultShow));
